import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from '@rn-platform/frontend-shared-ui-common';
import { AzureCredentialsConfig } from './azure-credentials-config';
import { AzureCredentialsModalService } from './azure-credentials-modal.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-azure-credentials',
    templateUrl: './azure-credentials.component.html',
    styleUrl: './azure-credentials.component.scss',
    standalone: false
})
export class AzureCredentialsComponent implements OnInit, OnDestroy {

  @ViewChild("modalRef") modalComponent: ModalComponent;


  private readonly azureCredentialsModalService = inject(AzureCredentialsModalService);
  private readonly subscriptions: Subscription[] = [];

  public configuration: AzureCredentialsConfig = new AzureCredentialsConfig();
  public entraUPN: string;
  public azureVirtualDesktopLink: string;

  constructor() {
  }

  ngOnInit(): void {
    this.entraUPN = this.configuration.entraUPN;
    this.azureVirtualDesktopLink = this.configuration.azureVirtualDesktopLink;
    const modalSub = this.azureCredentialsModalService.modalState$.subscribe(data => {
      if(!data) return;
      if (data?.config) {
        if (data?.isOpen) {
          this.open();
        }
        else {
          this.close();
        }
        this.configuration = data?.config;  
        this.entraUPN = this.configuration.entraUPN;
        this.azureVirtualDesktopLink = this.configuration.azureVirtualDesktopLink;
      }
    });
    this.subscriptions.push(modalSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  copyUPNToClipboard() {
    void navigator.clipboard.writeText(this.entraUPN);
  }
  open(): void {
    this.modalComponent?.open();
  }
  close(): void {
    this.modalComponent?.close();
  }
}
